import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import SchoolIcon from '@mui/icons-material/School';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import $ from 'jquery';
import { disciplineStyles } from "../../Assets/js/customStyles.js";

export default function StudentAnswerScriptList() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/college/");
    }

    const tableRef = useRef(null);

    const [loading, setlodaing] = useState(false);
    const { http } = Api();

    const [getexamData, setExamData] = useState([]);
    const [examid, setExamIdData] = useState(false);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [disciplineId, setDisciplineChange] = useState(false);
    const [disciplineNameChange, setDisciplineNameChange] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(false);
    const [selctedforcource, setselctedforcource] = useState(false);
    const [courseName, setCourseName] = useState(false);
    const [courseData, setCourseData] = useState([]);
    const [stat, setstat] = useState([]);



    const [bundilestatus, setBundilestatus] = useState([]);
    const [despatch, setDespatch] = useState(false);




    /* CUSTOME DATA TABLE BEGAINS HERE */

    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);

    /* CUSTOME DATA TABLE ENDS HERE */



    useEffect(() => {
        const fetchExamData = async () => {
            try {
                const response = await http.get(`College/getExamsForAnswerscript`);
                setExamData(response.data.examinations);
            }
            catch (error) {
                if (error.response.data.http_status === 403 && error.response.data.status_code == "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);

                }
                else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
                    toast.error(error.response.data.message);
                }
                else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
                    toast.error("No active exam found");
                }
                else {
                    toast.error(error.response.data.message);
                }
            }
        };

        fetchExamData();
    }, []);

    const handlExamChange = (selectedOption) => {

        setExamIdData(selectedOption.value);
        setDisciplineChange(false);
        setDisciplineData([]);
        setCourseData([]);



    };

    useEffect(() => {

        const fetchDisciplineData = async (selectedExamId) => {
            try {
                const response = await http.get(`College/getCollegeDisciplinesForAnswerscript`, {
                    params: {
                        examid: selectedExamId
                    },
                });
                setDisciplineData(response.data.disciplines);

            } catch (error) {

                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    // toast.error(error.response.data.message);
                } else {
                    // toast.error(error.response.data.message);
                }
            }
        };

        if (examid) {

            fetchDisciplineData(examid);
        }


    }, [examid])

    const handlDisciplineChange = async (selectedOption) => {


        setDisciplineChange(selectedOption.value);
        setDisciplineNameChange(selectedOption.label);
        setselctedforcource(false);
        setCourseData([]);

    };



    useEffect(() => {

        const fetchBundleCourseList = async (disciplineId, examId) => {

            try {
                const response = await http.get(`College/getCollegeBundleDespatchedCourseList`, {
                    params: {

                        discipline_id: disciplineId ? disciplineId : undefined,
                        examid: examId


                    },
                });
                console.log("response", response);
                setCourseData(response.data.courses);

                setstat(response.data.statistics);

            } catch (error) {
                if (error.response?.data?.http_status === 403 && error.response.data.status_code === "ERR37") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/college/");
                    }, 5000);
                } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        };


        if (disciplineId || examid) {

            fetchBundleCourseList(disciplineId, examid);
        }


    }, [disciplineId, examid])


    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
        }),

        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };




    const handleDispatchAll = () => {

        http.post(`College/saveBundileFacingSheetStatus`, {

            id: parseInt(localStorage.getItem("id")),
            examid: examid,
            course_id: selectedCourse
        },
        ).then((response) => {
            if (response.data.status_code === "MSG2") {
                toast.success("Dispatched Successfully");
                setDespatch(true);
            }
        }).catch((error) => {
            toast.error("Failed to dispatch");
        })

    }


    /* CUSTOME DATA TABLE BEGAINS HERE */

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    useEffect(() => {
        const filteredAndSortedData = [...courseData].filter(courseDatas => {
            return (
                (courseDatas.course_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
                (courseDatas.bundle_status?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
                (courseDatas.bundle_id?.toLowerCase() || '').includes(searchQuery.toLowerCase())
            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });


        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, courseData, currentPage]);


    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };


    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    /* CUSTOME DATA TABLE END HERE */

    const handleGenerateCourseBundlePDF = async () => {
        try {
            const response = await http.get('/College/getCollegeBundleDespatchedCourseListPDF', {
                params: {
                    discipline_id: disciplineId ? disciplineId : undefined,
                    examid: examid
                },
                responseType: 'blob'
            });

            if (response && response.data) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${localStorage.getItem('username')}_${disciplineNameChange}_CourseBundle.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                return Promise.resolve('PDF generated successfully ');

            }

        } catch (error) {
            console.error('Error generating PDF:', error);
            return Promise.reject('Error generating PDF');
        }
    };

    return (
        <>
            <ToastContainer />
            <Template>

                {loading ? (


                    <div className="container-fluid">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-sm-12">
                                <div className="card h-100">
                                    <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                        <div className="containeranimate">
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                            <div className="dot"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (


                    <div className="container-fluid" >

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center ">
                                                <h5>Bundle Despatch History</h5>
                                            </div>

                                        </div>
                                        <div className="card-body ">
                                            <div className="card-body pdg">
                                                {/* <div className="table-responsive"> */}
                                                <div className="form theme-form">
                                                    <div className="card-body custom-input">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label>Examination <span className="errorclr">*</span></label>

                                                                <Select
                                                                    styles={customStyles}
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="exam_id"
                                                                    name="exam_id"
                                                                    className="basic-select"
                                                                    classNamePrefix="select"

                                                                    options={getexamData.map(exam => ({
                                                                        value: exam.examid,
                                                                        label: exam.examtitle
                                                                    }))}

                                                                    onChange={handlExamChange}
                                                                    placeholder="Select an exam..."

                                                                    value={getexamData
                                                                        .filter(exam => exam.examid === examid ? examid : '')
                                                                        .map(exam => ({
                                                                            value: exam.examid,
                                                                            label: exam.examtitle
                                                                        }))}
                                                                />
                                                            </div>


                                                            <div className="col-md-6">
                                                                <label>Discipline<span className="errorclr">*</span></label>

                                                                <Select
                                                                    styles={disciplineStyles}

                                                                    maxMenuHeight={500}
                                                                    menuPlacement="auto"
                                                                    id="discipline_id"
                                                                    name="discipline_id"
                                                                    className="form"

                                                                    onChange={handlDisciplineChange}
                                                                    placeholder="Select an Discipline..."

                                                                    options={disciplinedata
                                                                        .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                        .map(discipline => ({

                                                                            value: discipline.id,
                                                                            label: discipline.discipline_name,

                                                                        }))

                                                                    }

                                                                    value={disciplinedata
                                                                        .filter(discipline =>
                                                                            discipline.id === disciplineId
                                                                        )
                                                                        .map(discipline => ({

                                                                            value: discipline.id,
                                                                            label: discipline.discipline_name,

                                                                        }))
                                                                    }



                                                                />

                                                            </div>




                                                        </div>






                                                        {/* CUSTOME DATA TABLE BEGAINS HERE */}


                                                        {courseData.length > 0 && (

                                                            <>

                                                                {/* <div className="col-xxl-12 col-xl-12 box-col-12 pdg11">
                                                                    <div className="row g-sm-3 height-equal-2 widget-charts">
                                                                        <div className="col-sm-4">
                                                                            <div className="card small-widget mb-sm-0">
                                                                                <div className="card-body primary"> <span className="f-light">Total courses</span>
                                                                                    <div className="d-flex align-items-end gap-1">
                                                                                        <h4>{stat.total_courses}</h4>
                                                                                    </div>
                                                                                    <div className="bg-gradient">
                                                                                        <svg className="stroke-icon svg-fill">
                                                                                            <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-sm-4">
                                                                            <div className="card small-widget mb-sm-0">
                                                                                <div className="card-body warning"><span className="f-light">Bundles Generated</span>
                                                                                    <div className="d-flex align-items-end gap-1">
                                                                                        <h4>{stat.bundles_generated}</h4>
                                                                                    </div>
                                                                                    <div className="bg-gradient">
                                                                                        <svg className="stroke-icon svg-fill">
                                                                                            <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-sm-4">
                                                                            <div className="card small-widget mb-sm-0">
                                                                                <div className="card-body secondary"><span className="f-light">Bundles Pending</span>
                                                                                    <div className="d-flex align-items-end gap-1">
                                                                                        <h4>{stat.bundles_pending}</h4>
                                                                                    </div>
                                                                                    <div className="bg-gradient">
                                                                                        <svg className="stroke-icon svg-fill">
                                                                                            <SchoolIcon sx={{ color: '#581f37' }} />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div> */}
                                                                <div className="card-body">
                                                              
                                                                <div className="table-responsive ovrflw">
                                                                    {filteredAndSortedData && filteredAndSortedData.length > 0 && (
                                                                            <div className="d-flex justify-content-end m-b-10">

                                                                                <button
                                                                                    className="lbl2 btn btn-primary"
                                                                                    onClick={handleGenerateCourseBundlePDF}
                                                                                    title="Export to PDF"
                                                                                >
                                                                                    <i className="bi bi-arrow-down-square"></i>
                                                                                </button>
                                                                            </div>
                                                                    )}
                                                                          
                                                                            <div className='row'>
                                                                                <div className='col-md-6 wdt' >
                                                                                    <p>
                                                                                        Showing {(currentPage - 1) * 50 + 1}{''}-
                                                                                        {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                                    </p>
                                                                                </div>
                                                                                <div className='col-md-6 wdt' align='right'>
                                                                                    <input
                                                                                        type="text"
                                                                                        value={searchQuery}
                                                                                        onChange={handleSearchInputChange}
                                                                                        placeholder="Search..."
                                                                                        className='form-control'
                                                                                    /></div></div>
                                                                            <table className="display dataTable table-striped table-bordered ex-v-table" ref={tableRef}>
                                                                                <thead>
                                                                                    <tr className="bg-primary">
                                                                                        <th onClick={() => handleSort('course_name')} style={{ textAlign: "center", verticalAlign: "middle" }}>Sl No &nbsp;
                                                                                            {renderSortIcon('course_name')} </th>
                                                                                        <th onClick={() => handleSort('course_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Course name  &nbsp;
                                                                                            {renderSortIcon('course_name')}</th>
                                                                                        <th onClick={() => handleSort('bundle_id')} style={{ textAlign: "center", verticalAlign: "middle" }} >Bundle ID &nbsp;
                                                                                            {renderSortIcon('bundle_id')}</th>
                                                                                        <th onClick={() => handleSort('bundle_status')} style={{ textAlign: "center", verticalAlign: "middle" }} >Bundle Status &nbsp;
                                                                                            {renderSortIcon('bundle_status')}</th>


                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {filteredAndSortedData.map((item, index) => {

                                                                                        const serialNumber = (currentPage - 1) * 50 + index + 1;

                                                                                        return (
                                                                                            <tr key={item.apaar_no}>
                                                                                                <td>{serialNumber}</td>

                                                                                                <td style={{ verticalAlign: "middle", }}>{item.course_name}</td>
                                                                                                {/* <td style={{verticalAlign: "middle",textAlign: "center" }}>{item.bundle_id}</td> */}

                                                                                                <td style={{ verticalAlign: "middle", textAlign: "center" }}>{item.bundle_id === null ? "-" : item.bundle_id}</td>

                                                                                                <td style={{ verticalAlign: "middle", textAlign: "center" }}>{item.bundle_status === null ? <span className="badge badge-warning">Pending</span> :
                                                                                                    <span className="badge badge-success">{item.bundle_status}</span>}</td>





                                                                                            </tr>
                                                                                        );

                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>

                                                                        {/* //pagination logic  */}
                                                                        {totalPages > 1 && (
                                                                            <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                                <ul className="pagination justify-content-center">
                                                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                                        <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                                                    </li>
                                                                                    <li className={`page-item`}>
                                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                                    </li>
                                                                                    {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                                    {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                                        <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                                        </li>
                                                                                    ))}
                                                                                    {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                                                    <li className={`page-item`}>
                                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                                    </li>

                                                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                                        <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                                                    </li>
                                                                                </ul>
                                                                            </nav>
                                                                        )}



                                                                </div>
                                                            </>

                                                        )}

                                                        {/* CUSTOME DATA TABLE END HERE */}


                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </Template>
        </>
    );
}
